import request from 'superagent';
import { setLocale } from 'react-redux-i18n';

export default function changeLang(lang) {
  return dispatch => {
    if (typeof window !== 'undefined' && window) {
      window.localStorage.setItem('lang', lang);
      document.documentElement.setAttribute('lang', lang);
    }

    dispatch(setLocale(lang));

    request
      .post('/user/language')
      .send({ language: lang })
      .end(() => {});
  };
}
